import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import IconCancel from '@mui/icons-material/Cancel';
import {
    Button,
    DateInput,
    SaveButton,
    SimpleForm,
    TextInput,
} from 'react-admin';

import { formatBytes } from '@src/utils/number-helpers';

import ImagePreviewInput from '@src/components/images/image-preview-input';

import Moment from 'moment';

const EditImageForm = (props) => {
    const { image, updating, onCancel, onSubmit } = props;

    return (
        <SimpleForm
            record={image}
            toolbar={
                <Toolbar
                    disableGutters
                    sx={{ justifyContent: 'flex-end' }}
                >
                    <Button
                        sx={{ marginLeft: 2 }}
                        label="ra.action.cancel"
                        disabled={updating}
                        onClick={onCancel}
                    >
                        <IconCancel />
                    </Button>
                    <SaveButton
                        sx={{ marginLeft: 2 }}
                        saving={updating}
                    />
                </Toolbar>
            }
            onSubmit={onSubmit}
        >
            <Grid container sx={{ width: '100%' }}>
                <Grid size={12}>
                    <TextInput
                        fullWidth
                        required
                        label="Alternate text"
                        source="alt"
                    />
                </Grid>
                <Grid size={12}>
                    <DateInput
                        fullWidth
                        label="Expiration Date"
                        source="expired_at"
                        parse={(v) => Moment(v).toISOString()}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <ImagePreviewInput source="source" record={image} />
                </Grid>
                <Grid
                    container
                    size={{ xs: 12, md: 6 }}
                >
                    <Grid size={3}>
                        <TextInput label="File type" source="format" inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid size={3}>
                        <TextInput source="width" inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid size={3}>
                        <TextInput source="height" inputProps={{ readOnly: true }} />
                    </Grid>
                    <Grid size={3}>
                        <TextInput label="Size" source="bytes" format={formatBytes} inputProps={{ readOnly: true }} />
                    </Grid>
                </Grid>
            </Grid>
        </SimpleForm>
    );
};

EditImageForm.propTypes = {
    image: PropTypes.object.isRequired,
    updating: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default EditImageForm;
